import React from 'react'
import { useState } from 'react';
import axios from 'axios';


function CreateAttribute() {
  const [attributename, setAttributename] = useState('');
  const [attributetype, setAttributeType] = useState('');
  const [code, setCode] = useState('');
  const [attributegroup, setAttributeGroup] = useState('');
  const [attributetab, setAttributeTab] = useState('');
  const [defaultscope, setDefaultScope] = useState('');
  const [defaultchannel, setDefaultChannel] = useState('');
  const sendData = async (e) => {
      
      try {
        e.preventDefault();
        const formdata=new FormData();
        formdata.append('attributename',attributename);
        formdata.append('attributetype',attributetype);
        formdata.append('code',code);
        formdata.append('attributegroup',attributegroup);
        formdata.append('attributetab',attributetab);
        formdata.append('defaultscope',defaultscope);
        formdata.append('defaultchannel',defaultchannel);
        const response = await axios.post(process.env.REACT_APP_API_URL+'/api/brands', formdata)
        console.log(response);
      }
      catch (error) {
        console.error(error);
      }
    }
  return (
    <>
    <div >
      <p className='m-6 text-xl'>Create Attribute Group</p>
    <form class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4" onSubmit={sendData}>
  <div class="mb-4">
    <label class="block text-gray-700 text-sm font-bold mb-2" for="groupname">
      Attribute Name
    </label>
    <input class="shadow appearance-none border rounded w-96 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="groupname" type="text" placeholder="Group Name" onChange={(e)=>setAttributename(e.target.value)}/>
  </div>
  <div class="mb-4">
    <label class="block text-gray-700 text-sm font-bold mb-2" for="AttributeType">
      Attribute Type
    </label>
    <input class="shadow appearance-none border rounded w-96 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="code" type="text" placeholder="Code" onChange={(e)=>setAttributeType(e.target.value)} />
  </div>
  <div class="mb-4">
    <label class="block text-gray-700 text-sm font-bold mb-2" for="code">
      Code
    </label>
    <input class="shadow appearance-none border rounded w-96 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="code" type="text" placeholder="Code" onChange={(e)=>setCode(e.target.value)} />
  </div>
  <div class="mb-4">
    <label class="block text-gray-700 text-sm font-bold mb-2" for="attributegroup">
      Attribute Group
    </label>
    <input class="shadow appearance-none border rounded w-96 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="sortorder" type="text" placeholder="Sort Order" onChange={(e)=>setAttributeGroup(e.target.value)}/>
  </div>
  <div class="mb-4">
    <label class="block text-gray-700 text-sm font-bold mb-2" for="attributetab">
      Attribute Tab
    </label>
    <input class="shadow appearance-none border rounded w-96 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="sortorder" type="text" placeholder="Sort Order" onChange={(e)=>setAttributeTab(e.target.value)}/>
  </div>
  <div class="mb-4">
    <label class="block text-gray-700 text-sm font-bold mb-2" for="defaultscope">
      Default Scope
    </label>
    <input class="shadow appearance-none border  w-96 py-2 px-3 text-gray-700 leading-tight focus:outline-none " id="sortorder" type="text" placeholder="Sort Order" onChange={(e)=>setDefaultScope(e.target.value)}/>
  </div>
  <div class="mb-4">
    <label class="block text-gray-700 text-sm font-bold mb-2" for="defaultchannel">
      Default Channel
    </label>
    <input class="shadow appearance-none border  w-96 py-2 px-3 text-gray-700 leading-tight focus:outline-none " id="sortorder" type="text" placeholder="Sort Order" onChange={(e)=>setDefaultChannel(e.target.value)}/>
  </div>
  <div class="flex items-center justify-between">
    <button class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline" type="submit">
      Create
    </button>
  </div>
  </form>
  </div>
    </>
    
  )
}

export default CreateAttribute